module.exports = __webpack_public_path__ + "media/images/area/icon_weather_17-d2b5b33fbd84f8fd703d996cebe113ba.png";